module.exports = __webpack_public_path__ + "img/geschirrreinigung.5cc635a.png";